import { coinRegexPatterns } from "@lib/constants/Coin";
import { WalletAddressStatus, WalletAddressType } from "@lib/types/Billing";
import { DashboardWallet } from "@lib/types/Dashboard";

export function validateAddress(coinType: WalletAddressType, address: string) {
  if (!coinRegexPatterns[coinType]) return false;

  // console.log("🚀 ~ validateAddress:", coinType, address);
  if (Array.isArray(coinRegexPatterns[coinType])) {
    return coinRegexPatterns[coinType].some((pattern) => pattern.test(address));
  }
  return coinRegexPatterns[coinType].test(address);
}

export const findTotalWalletAddress = (
  data: DashboardWallet[],
  type: WalletAddressType,
  status?: WalletAddressStatus,
): number => {
  try {
    const arr = data.map((d) => {
      let count = 0;
      for (let index = 0; index < d.statusCounts.length; index++) {
        if (status) {
          if (
            d.statusCounts[index].network === type &&
            status === d.statusCounts[index].status
          ) {
            count += Number(d.statusCounts[index].count);
          }
        } else {
          if (d.statusCounts[index].network === type) {
            count += Number(d.statusCounts[index].count);
          }
        }
      }
      return count;
    });

    let count = 0;
    for (let index = 0; index < arr.length; index++) {
      count += arr[index];
    }
    return count;
  } catch (error) {
    return NaN;
  }
};
